import React from 'react';
import { PlayCircleIcon } from '@fronton/icons-react';
import { transformVideoThumb } from 'utils/transform-video-thumb';
import { Hover } from '../types';
import { thumb, videoThumbIcon, videoThumbBg, videoThumbIconBg } from './styles';
import { useOptimisedImages } from '@navi-toolbox/hooks';

export type Props = {
  src: string;
  index: number;
  onMouseEnterCb: (type: string, src: string, index: Hover) => void;
  onMouseLeaveCb: () => void;
  onClick: (mediaType: string, imgSrc: string, index: number) => void;
};

function ThumbVideo({ src, index, onClick, onMouseEnterCb, onMouseLeaveCb }: Props) {
  const videoSrc = transformVideoThumb(src);

  const optimizedImage = useOptimisedImages({
    src: videoSrc,
    sizes: {
      thumb: {
        h: '160',
        w: '169',
      },
    },
  });

  function handleClick() {
    onClick?.('mediaVideo', src, index);
  }

  return (
    <div
      data-qa="thumb-item-video"
      onClick={handleClick}
      onMouseEnter={() => onMouseEnterCb('mediaVideo', src, index)}
      onMouseLeave={onMouseLeaveCb}
      className={thumb}
    >
      <PlayCircleIcon
        className={videoThumbIcon}
        type="fill"
        color="background-secondary"
        size="xxl"
        data-qa="thumb-icon"
      />
      {videoSrc ? (
        <div
          className={videoThumbBg}
          style={{
            backgroundImage: `url(${optimizedImage.thumb.x})`,
          }}
        />
      ) : (
        <div className={videoThumbIconBg} />
      )}
    </div>
  );
}

export { ThumbVideo };
